/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './starterpack.defs'
export { main as default } from './starterpack.defs'
